function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesClosetFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 14a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4a2 2 0 012-2h22a2 2 0 012 2v26H3V4zm2 0h10v24H5V4zm12 4V4h10v4H17zm0 20V10h4v1.793l-1.622 1.287a1 1 0 00-.378.784V22a1 1 0 001 1h4a1 1 0 001-1v-8.136a1 1 0 00-.378-.784L23 11.793V10h4v18H17zm6-7v-6.653l-1-.794-1 .794V21h2z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesClosetFilled;